import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import './ProductCard.css';

const ProductCard = ({ producto }) => {

  return (
    <div className="product-card">
      <div className="card-image-container">
        <Link to={`/productos/${producto.id}`}>
          <img src={producto.imagen_url} alt={producto.nombre} className="card-image" />
        </Link>
      </div>
      
      <div className="card-content">
        <Link to={`/productos/${producto.id}`} className="card-title-link">
          <h3>{producto.nombre}</h3>
        </Link>
        <p className="card-description">{producto.descripcion}</p>
        

        <div className="card-actions">
          <Link to={`/productos/${producto.id}`} className="btn-ver-mas">
            Ver detalle
          </Link>
          <Link to="/productos" className="btn-ver-mas">
            Ver catálogo
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;